module.exports = __webpack_public_path__ + "img/PLUS.11a5eed1.svg";